module.exports = __webpack_public_path__ + "static/123-03-03-cb1d3b31495c2307e356e6d11c81b804.png";